// The browser can take a canvas's 2D context away - iOS does it to a page that
// has been in the background, and memory pressure can do it anywhere - and hands
// back a fresh one with contextrestored. Everything set on the old context is
// gone, the retina scale fabric put on it included, so the next render drew at a
// fraction of the size or left the canvas blank until something else redrew it.
// Fabric has two canvases, the lower one with the design and the upper one with
// the selection and controls; both get their scale back and are drawn again.
export default function restoreOnContextLoss(canvas) {
	const elements = [canvas.lowerCanvasEl, canvas.upperCanvasEl].filter(Boolean);
	const onRestored = () => {
		canvas._initRetinaScaling();
		canvas.requestRenderAll();
	};
	elements.forEach(el => el.addEventListener('contextrestored', onRestored));
	return () => {
		elements.forEach(el => el.removeEventListener('contextrestored', onRestored));
	};
}
